import { NgModule } from '@angular/core';
import { ToUpperCaseDirective } from './to-upper-case/to-upper-case.directive';

@NgModule({
    declarations: [
        // AriaInputDirective,
        ToUpperCaseDirective
    ],
    exports: [
        // AriaInputDirective,
        ToUpperCaseDirective
    ]
})
export class DirectivesModule {
}
